import { Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Action, SilkEditor, SilkView } from 'silk-editor';

import { ComponentEvent, RxComponent } from 'app/core/components/common/rx.component';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Observable } from 'rxjs/Observable';

declare var $: any;

export const EDITOR_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SilkEditorComponent),
    multi: true,
};

export interface ISilkConfig {
    hideToolbar?: boolean;
    placeholder?: string;
}

@Component({
    selector: 'silk-editor',
    templateUrl: './silk-editor.component.html',
    styleUrls: ['./silk-editor.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [EDITOR_VALUE_ACCESSOR]
})
export class SilkEditorComponent extends RxComponent implements ControlValueAccessor {

    @ViewChild('editor') editor: ElementRef;
    wrapper: SilkView;
    view: SilkEditor;

    @Input() actionDispatcher$: Observable<Action>;
    @Input() focusReset$: Observable<void>;
    @Input() config: ISilkConfig;
    @Input() onlyTextFormattingSection: boolean;

    @Output() stateChanged$ = new EventEmitter();
    valueUpdated$ = new ReplaySubject();
    isInTable$ = new ReplaySubject();

    changeFn = (value) => {
    };

    constructor() {
        super();
    }

    ngOnInit() {
        this.wrapper = new SilkView();

        const valueChanged = this.valueUpdated$
        // It's important to wait for the afterContentInit hook
            .waitUntil(this.getLifecycle().filter(e => e === ComponentEvent.AfterContentInit))
            .share();

        valueChanged
        // We need to wait a bit since react's and angular update hooks are not synchronized
        // This should be fixed when using ngui/react
            .delay(50)
            .take(1)
            .bindToLifecycle(this)
            .subscribe(value => this.initializeEditor(value));

        valueChanged
            .skip(1)
            .bindToLifecycle(this)
            .subscribe(value => this.view.setState(value));

        if (this.actionDispatcher$) {
            this.actionDispatcher$
                .bindToLifecycle(this)
                .subscribe(action => this.dispatchAction(action));
        }

        if (this.focusReset$) {
            this.focusReset$
                .bindToLifecycle(this)
                .subscribe(() => this.resetFocus());
        }
    }

    private dispatchAction(action: Action) {
        if (this.view) {
            this.view.dispatchAction(action);
            this.resetFocus();
        }
    }

    private initializeEditor(initialValue) {
        const placeholder = this.config ? this.config.placeholder : '';
        this.view = this.wrapper.initialize(this.editor.nativeElement, {
            onChange: (state, isInTable) => {
                this.isInTable$.next(isInTable);
                this.stateChanged$.next(state);
                this.changeFn(state);
            },
            initialValue: initialValue,
            placeholder
        });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        if (this.view) this.wrapper.dispose();
    }

    resetFocus() {
        if (this.view) this.view.focus();
    }

    writeValue(obj: any): void {
        this.valueUpdated$.next(obj);
    }

    registerOnChange(fn: any): void {
        this.changeFn = fn;
    }

    registerOnTouched(fn: any): void {
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/silk/silk-editor/silk-editor.component.ts